import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

import Button from "@/components/button.vue"
  import SupplierEditor from "@/components/editors/supplier.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import {useRoute} from "vue-router"
  import {Supplier as SupplierClient} from "@/endpoints/rutsolve/gql/resolvers/supplier"
  import {ContactDetails as ContactDetailsClient} from "@/endpoints/rutsolve/gql/resolvers/contact_details"
  import {onBeforeMount, ref} from "vue"
  import {ContactDetails, Supplier} from "@/endpoints/rutsolve/gql/generated/graphql"
  import ErrorModal from "@/components/modals/error.vue"
  import ConfirmationModal from "@/components/modals/confirmation.vue"
  import router from "@/router"
  import ContactDetailsList from "@/components/lists/contact_details.vue"
  import ContactDetailsEditor from "@/components/editors/contact_details.vue"
  import ContentModal from "@/components/modals/content.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'edit_supplier',
  setup(__props) {

  const error = ref<Error>(null)
  const contactDetailsClient = new ContactDetailsClient()
  const supplierClient = new SupplierClient()
  const supplier = ref<Supplier>(null)
  const confirmRemove = ref<boolean>(false)
  const selectedContactDetails = ref<ContactDetails>(null)
  const selectedContactDetailsIndex = ref<number>(null)

  onBeforeMount(() => {
    read()
  })

  async function read() {
    try {
      const supplierID = useRoute().params.supplierID.toString()
      supplier.value = await supplierClient.summary(supplierID)
      if (!supplier.value.contactDetails || !supplier.value.contactDetails.records) {
        supplier.value.contactDetails = {
          records: []
        }
      }
    } catch(e) {
      error.value = e
    }
  }

  async function remove() {
    try {
      await supplierClient.remove(supplier.value.id)
      suppliersRedirect()
    } catch(e) {
      error.value = e
    }
  }

  async function save() {
    try {
      await supplierClient.update(supplier.value)
      for (const contactDetails of supplier.value.contactDetails.records) {
        contactDetails.relationID = supplier.value.id
        contactDetails.relationType = "SUPPLIER"
        if (contactDetails.deletedAt) {
          await contactDetailsClient.remove(contactDetails.id)
        } else if (contactDetails.id) {
          await contactDetailsClient.update(contactDetails)
        } else {
          await contactDetailsClient.create(contactDetails)
        }
      }
      suppliersRedirect()
    } catch(e) {
      error.value = e
    }
  }
  
  function suppliersRedirect() {
    router.push({
      name: "suppliers"
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(VerticalNavigator, null, {
        default: _withCtx(() => [
          (supplier.value)
            ? (_openBlock(), _createBlock(Breadcrumb, {
                key: 0,
                links: [{
          title: 'RutSolve',
          routeName: 'index'
        }, {
          title: 'Suppliers',
          routeName: 'suppliers'
        }],
                title: supplier.value.name
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          _cache[12] || (_cache[12] = _createElementVNode("h1", null, " Edit Supplier ", -1)),
          _createVNode(SupplierEditor, {
            value: supplier.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((supplier).value = $event))
          }, null, 8, ["value"]),
          _cache[13] || (_cache[13] = _createElementVNode("h2", null, " Contact Details ", -1)),
          (supplier.value && supplier.value.contactDetails)
            ? (_openBlock(), _createBlock(ContactDetailsList, {
                key: 1,
                items: supplier.value.contactDetails.records,
                "onUpdate:items": _cache[1] || (_cache[1] = ($event: any) => ((supplier.value.contactDetails.records) = $event)),
                selectedIndex: selectedContactDetailsIndex.value,
                "onUpdate:selectedIndex": _cache[2] || (_cache[2] = ($event: any) => ((selectedContactDetailsIndex).value = $event)),
                onSelect: _cache[3] || (_cache[3] = ($event: any) => (selectedContactDetails.value = supplier.value.contactDetails.records[selectedContactDetailsIndex.value]))
              }, null, 8, ["items", "selectedIndex"]))
            : _createCommentVNode("", true),
          (selectedContactDetails.value)
            ? (_openBlock(), _createBlock(ContentModal, { key: 2 }, {
                default: _withCtx(() => [
                  _createVNode(ContactDetailsEditor, {
                    value: selectedContactDetails.value,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((selectedContactDetails).value = $event))
                  }, null, 8, ["value"]),
                  _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                  _createVNode(Button, {
                    title: "Apply",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (selectedContactDetails.value = null))
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(Button, {
            title: "Remove",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (confirmRemove.value = true))
          }),
          _createVNode(Button, {
            title: "Cancel",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (suppliersRedirect()))
          }),
          _createVNode(Button, {
            title: "Save",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (save()))
          })
        ]),
        _: 1
      }),
      _createVNode(ConfirmationModal, {
        display: confirmRemove.value,
        "onUpdate:display": _cache[9] || (_cache[9] = ($event: any) => ((confirmRemove).value = $event)),
        callback: remove,
        message: "This action will remove selected supplier.",
        title: "Remove Supplier"
      }, null, 8, ["display"]),
      (error.value)
        ? (_openBlock(), _createBlock(ErrorModal, {
            key: 0,
            error: error.value,
            "onUpdate:error": _cache[10] || (_cache[10] = ($event: any) => ((error).value = $event))
          }, null, 8, ["error"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})